import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Define styles for the PDF
const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  header: { fontSize: 16, marginBottom: 20, textAlign: 'center', fontWeight: 'bold', color: '#333' },
  infoSection: { marginBottom: 20, padding: 10, backgroundColor: '#f0f0f0', borderRadius: 4 },
  infoRow: { flexDirection: 'row', marginBottom: 5 },
  label: { width: 100, fontWeight: 'bold' },
  table: { display: 'table', width: 'auto', marginTop: 10, borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf' },
  tableHeader: { flexDirection: 'row', backgroundColor: '#444', color: '#fff' },
  tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eee' },
  tableCol: { width: '25%', padding: 5, borderRightWidth: 1, borderRightColor: '#bfbfbf' },
  tableColEnd: { width: '25%', padding: 5, textAlign: 'right' },
  headerText: { fontWeight: 'bold' }
});

const StaffPDF = ({ data }) => {
  // Date formatter for PDF
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>Staff Details Report</Text>

        <View style={styles.infoSection}>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Staff Name:</Text>
            <Text>{data.staff_name}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Role:</Text>
            <Text>{data.role}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Daily Wages:</Text>
            <Text>Rs. {data.wages_amount}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Advance Bal:</Text>
            <Text>Rs. {data.advance_balance || 0}</Text>
          </View>
        </View>

        <Text style={{ fontSize: 12, marginBottom: 5, fontWeight: 'bold' }}>Advance History</Text>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.tableCol}>Date</Text>
            <Text style={styles.tableCol}>Type</Text>
            <Text style={styles.tableCol}>Mode</Text>
            <Text style={styles.tableColEnd}>Amount</Text>
          </View>
          {data.advance_history?.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.tableCol}>{formatDate(item.entry_date)}</Text>
              <Text style={styles.tableCol}>{item.type}</Text>
              <Text style={styles.tableCol}>{item.recovery_mode || "N/A"}</Text>
              <Text style={styles.tableColEnd}>
                {item.type === 'add' ? `+${item.amount}` : `-${item.amount}`}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default StaffPDF;